import { SalesDiscountProductType } from './sales-discount-product-type';

export interface SalesDiscount {
  id: string;
  key: string;
  description: string;
  discountRate: number;

  salesDiscountProductTypes: SalesDiscountProductType[];
}
